import React from "react";
import { createMuiTheme, withStyles, makeStyles, ThemeProvider  } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Link, Container } from "@material-ui/core";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { Grid } from "@material-ui/core";
import Nav from "../nav";

const ActionButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontWeight: 600,
    fontSize: 18,
  padding: "5px 12px",
    borderRadius: 8,
    minWidth: 220,
  minHeight: 36,
    backgroundColor: "#fb741a",
    color: "#fff",
    boxShadow: '0 6px 18px rgba(0,0,0,0.72)',
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:hover": {
      backgroundColor: "#002D55",
      boxShadow: "none"
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#0062cc",
      borderColor: "#005cbf"
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    },
    ["@media (max-width:600px)"]: {
      fontSize: 13,
      padding: "24px 35px 24px 35px",
      minWidth: 260,
      height: 28,
    },
    ["@media (min-width:600px) and (max-width:960px)"]: {
      fontSize: 14,
      padding: "26px 35px 26px 35px",
      minWidth: 279,
      height: 32,
    },
    ["@media (min-width:960px) and (max-width:1280px)"]: {
      fontSize: 15,
      padding: "28px 35px 28px 35px",
      minWidth: 280,
      height: 34,
    },
    ["@media (min-width:1280px) and (max-width:1920px)"]: {
      fontSize: 17,
      padding: "28px 35px 28px 35px",
      minWidth: 290,
      height: 36,
    },
    ["@media (min-width:1920px)"]: {
      fontSize: 20,
      padding: "28px 35px 28px 35px",
      minWidth: 300,
      height: 40,
    }
  }
})(Button);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(0.5),
  }
}));

function StartAssessment(nav) {
  window.location.replace(nav);
};

export default function StartButton() {
  const classes = useStyles();

  return (
    <div>
      <ActionButton
        variant="contained"
        color="primary"
        disableRipple
        className={classes.margin}
        onClick={() => {StartAssessment("/virtual_consultation")}}
      >
        <h3>START ASSESSMENT</h3>
      </ActionButton>
    </div>
  );
}

//const useStyles = makeStyles((theme) => ({
//    Button: {
//        color: "#002D55",
//    }
//}));
////Button, der skal starte questionaire når den trykkes og loade en embedded page på landingpage
//export default function StartButton() {
//
//    return (
//        <div className="StartButton"  >
//            <Grid container>           
//                <Button 
//                    onClick={()=>Link("ref")} 
//                    variant="outlined"
//                    color="#002D55">
//                        <PlayArrowIcon /> 
//                    Start Consultation
//                </Button>
//            </Grid>
//        </div>
//    )
//}
//
//// Skal komme frem i embedded page når der trykkes på knappen
////return (
////    <div>
//        <TextField
//            id="standard-textarea"
//            label="Type your answer here"
//            placeholder="Placeholder"
//            multiline
//            //className={classes.textField}
//            margin="normal"
//            //value={props.fullName}
//            //onChange={props.handleChange}
//        />
//    </div>
//);